/* ==========================================================================
   SMT Story System  —  smt-dw-pdp.js  (v2.2.1)
   Product page behaviour. Vanilla JS, no framework. Powers:
     - option selection (colour swatches, size pills, other pills) -> variant
     - live availability per size for the chosen colour
     - colour-filtered gallery with angle chips and a zoom dialog; each colour's
       first photo is fetched ahead of time and a switch waits for it to decode;
       a colour with no photos of its own keeps the photos already up (or the
       first colour's) and a note names the colour they show
     - delivery-aware CTA states: pick / ready / sold out / busy
     - add to bag through window.SMTDW (smt-dw.js), cart drawer kept in sync
     - the mobile buy dock, shown only while the real button is off screen; floating
       app buttons (chat, rewards, badges) move up out of its way while it shows
     - the size finder (chest + preference -> recommended size)
     - signature sleeve marks open that sleeve's photo full size
   Loaded with `defer` after smt-dw.js; guarded against double init.
   ========================================================================== */
(function () {
  'use strict';
  if (window.SMTDWPDP) return;
  var PDP = (window.SMTDWPDP = { version: '2.2.1' });

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  function DW() { return window.SMTDW || null; }
  function money(cents, fmt) { var d = DW(); return d ? d.money(cents, fmt) : '$' + (cents / 100).toFixed(2); }
  function tight(s) { return String(s || '').toLowerCase().replace(/\s+/g, ''); }
  /* colour names as shown: "Black/ Neon Pink" -> "Black/Neon Pink" (values stay raw for matching) */
  function nice(s) { return String(s || '').replace(/\s*\/\s*/g, '/'); }

  function init(root) {
    if (root.dataset.dwPdpReady) return;
    root.dataset.dwPdpReady = '1';

    var data;
    try { data = JSON.parse(($('[data-dw-pdp-data]', root) || {}).textContent || '{}'); } catch (e) { data = {}; }
    var variants = data.variants || [];
    var names = data.optionNames || [];
    var ci = typeof data.colorIndex === 'number' ? data.colorIndex : -1;
    var si = typeof data.sizeIndex === 'number' ? data.sizeIndex : -1;
    var fmt = data.moneyFormat || '${{amount}}';

    var groups = $$('[data-dw-opt]', root);
    var picks = names.map(function () { return ''; });
    groups.forEach(function (g) {
      var idx = Number(g.dataset.dwOpt);
      var on = $('[data-dw-val][aria-pressed="true"]', g);
      if (on) picks[idx] = on.dataset.dwVal;
    });
    /* a variant named in the URL wins over the rendered defaults */
    if (data.initial) {
      var v0 = variants.filter(function (v) { return v.id === data.initial; })[0];
      if (v0) picks = v0.o.slice();
    }

    var priceEls = $$('[data-dw-price]', root);
    var compareEl = $('[data-dw-compare]', root);
    var packEl = $('[data-dw-pack]', root);
    var idInput = $('[data-dw-variant-id]', root);
    var form = $('[data-dw-form]', root);
    var cta = $('[data-dw-cta]', root);
    var dock = $('[data-dw-dock]', root);
    var dockCta = $('[data-dw-dock-cta]', root);
    var errEl = $('[data-dw-error]', root);
    var afterAdd = root.dataset.dwAfterAdd || 'drawer';

    function complete() { return picks.every(function (p) { return p !== ''; }); }
    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] && v.o[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function current() { return complete() ? match(picks) : null; }
    function anyAvailable(idx, val) {
      var probe = picks.slice(); probe[idx] = val;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = v.a;
        for (var j = 0; ok && j < probe.length; j++) { if (j !== idx && j !== si && probe[j] && v.o[j] !== probe[j]) ok = false; }
        if (ok && v.o[idx] === val) return true;
      }
      return false;
    }
    /* for size pills: available for the chosen colour (and other options) */
    function sizeAvailable(val) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]; if (!v.a || v.o[si] !== val) continue;
        var ok = true;
        for (var j = 0; j < picks.length; j++) { if (j !== si && picks[j] && v.o[j] !== picks[j]) { ok = false; break; } }
        if (ok) return true;
      }
      return false;
    }

    function priceFor(v) {
      var p = v ? v.p : (variants[0] ? variants[0].p : 0);
      priceEls.forEach(function (el) { el.textContent = money(p, fmt); });
      if (compareEl) {
        var cp = v ? v.cp : 0;
        compareEl.hidden = !(cp > p);
        if (cp > p) compareEl.textContent = money(cp, fmt);
      }
      if (packEl) {
        var pct = Number(packEl.dataset.pct || 0);
        if (pct > 0) packEl.textContent = money(Math.round(p * (100 - pct) / 100), fmt) + ' each with a second ' + (data.packLabel || 'piece') + ' piece';
      }
    }

    function missingName() {
      for (var i = 0; i < picks.length; i++) { if (!picks[i]) return names[i] || 'option'; }
      return '';
    }

    function paint() {
      groups.forEach(function (g) {
        var idx = Number(g.dataset.dwOpt);
        var label = $('[data-dw-opt-value]', g);
        if (label) label.textContent = nice(picks[idx]);
        $$('[data-dw-val]', g).forEach(function (b) {
          var on = b.dataset.dwVal === picks[idx];
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (idx === si) b.classList.toggle('is-off', !sizeAvailable(b.dataset.dwVal));
          else if (idx !== ci) b.classList.toggle('is-off', !anyAvailable(idx, b.dataset.dwVal));
        });
      });
      var v = current();
      priceFor(v || (ci >= 0 ? match(picks.map(function (p, i) { return i === ci ? p : ''; })) : null));
      if (idInput) idInput.value = v ? v.id : '';
      var state, label;
      if (!complete()) { state = 'pick'; label = 'Choose a ' + missingName().toLowerCase(); }
      else if (!v) { state = 'off'; label = 'Not available'; }
      else if (!v.a) { state = 'off'; label = 'Sold out in ' + picks.filter(Boolean).map(nice).join(', '); }
      else { state = 'ready'; label = data.ctaLabel || 'Add to bag'; }
      [cta, dockCta].forEach(function (b) {
        if (!b) return;
        b.dataset.state = state;
        b.disabled = state === 'off';
        b.textContent = label;
      });
      if (v && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          if (url.searchParams.get('variant') !== String(v.id)) { url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); }
        } catch (e) {}
      }
      if (errEl) errEl.hidden = true;
    }

    groups.forEach(function (g) {
      var idx = Number(g.dataset.dwOpt);
      $$('[data-dw-val]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          picks[idx] = b.dataset.dwVal;
          if (idx === ci) showColour(b.dataset.dwVal);
          paint();
        });
        if (idx === ci) {
          /* start loading a colour's photos the moment a shopper reaches for it */
          var reach = function () { warmColour(b.dataset.dwVal, 3); };
          b.addEventListener('pointerenter', reach, { passive: true });
          b.addEventListener('touchstart', reach, { passive: true });
          b.addEventListener('focus', reach);
        }
      });
    });

    /* ---------- gallery ---------- */
    var gallery = $('[data-dw-gallery]', root);
    var slides = $$('[data-dw-slide]', root);
    var angles = $('[data-dw-angles]', root);
    var desktop = window.matchMedia('(min-width: 900px)');

    /* the wide first photo on desktop spans both gallery columns (~52vw) */
    var WIDE_SIZES = '(min-width: 1440px) 740px, (min-width: 900px) 52vw, 100vw';
    /* the server renders data-dw-sizes (the normal sizes) because the lead photo may arrive wide */
    slides.forEach(function (s) { var im = $('img', s); if (im && !im.dataset.dwSizes) im.dataset.dwSizes = im.getAttribute('sizes') || ''; });
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
    var frugal = !!conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '');
    var idle = window.requestIdleCallback ? function (fn) { window.requestIdleCallback(fn, { timeout: 2500 }); } : function (fn) { setTimeout(fn, 400); };

    function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }
    /* no colour choice on this piece: every photo shows */
    var coloured = ci >= 0 ? slides.filter(function (s) { return !!s.dataset.color; }) : [];
    var noteSlot = $('[data-dw-photo-note]', root);
    var shown = '';
    function hasPhotos(colour) {
      var key = tight(colour);
      return !!key && coloured.some(function (s) { return tight(s.dataset.color) === key; });
    }
    /* the colour whose photos stand for this one: itself when it has photos,
       otherwise the colour already on show, otherwise the first photographed one */
    function standIn(colour) {
      if (!coloured.length || hasPhotos(colour)) return colour;
      if (hasPhotos(shown)) return shown;
      return coloured[0].dataset.color;
    }
    /* the slides a colour shows: its (stand-in's) photos plus any photo with no colour */
    function slidesFor(colour) {
      if (!coloured.length) return slides.slice();
      var key = tight(standIn(colour));
      return slides.filter(function (s) { return !s.dataset.color || tight(s.dataset.color) === key; });
    }
    function note(colour, use) {
      if (!noteSlot) return;
      var miss = coloured.length && colour && tight(use) !== tight(colour);
      var cur = $('.dw-pdp__photo-note', noteSlot);
      var text = miss ? 'No photos of ' + nice(colour) + ' yet. These show ' + nice(use) + '.' : '';
      if (!text) { if (cur) noteSlot.innerHTML = ''; return; }
      if (cur && cur.textContent === text) return;
      var el = document.createElement('p');
      el.className = 'dw-pdp__photo-note';
      el.textContent = text;
      noteSlot.innerHTML = '';
      noteSlot.appendChild(el);
    }
    /* an odd count leads with a wide photo; the class only takes effect on desktop (css), as the server renders it */
    function wideFirst(vis) { return vis.length > 1 && vis.length % 2 === 1; }
    function sizeFor(s, wide) {
      var im = $('img', s);
      if (!im) return;
      var want = wide ? WIDE_SIZES : (im.dataset.dwSizes || im.getAttribute('sizes') || '');
      if (want && im.getAttribute('sizes') !== want) im.setAttribute('sizes', want);
    }
    function eager(list, n) {
      list.slice(0, n).forEach(function (s) {
        var im = $('img', s);
        if (im && im.getAttribute('loading') !== 'eager') im.setAttribute('loading', 'eager');
      });
    }
    /* load a colour's first photos ahead of time, at the size they will show */
    function warmColour(colour, n) {
      var vis = slidesFor(colour);
      if (vis[0] && vis[0].hidden) sizeFor(vis[0], wideFirst(vis));
      eager(vis, n || 1);
      return vis;
    }
    function filterGallery(colour) {
      var use = standIn(colour);
      var vis = slidesFor(colour);
      var wide = wideFirst(vis);
      shown = use;
      note(colour, use);
      slides.forEach(function (s) {
        s.hidden = vis.indexOf(s) < 0;
        s.classList.toggle('is-wide', wide && s === vis[0]);
        sizeFor(s, wide && s === vis[0]);
      });
      buildAngles(vis);
      if (gallery && !desktop.matches) gallery.scrollTo({ left: 0, behavior: 'auto' });
      /* the first photos of the chosen colour should not wait for lazy loading */
      eager(vis, 2);
    }
    /* switch colours without a blank frame: keep the current photos up until
       the new colour's first photo is decoded (never longer than 350ms) */
    var galleryTurn = 0;
    function showColour(colour) {
      var turn = ++galleryTurn;
      var vis = warmColour(colour, 3);
      var lead = vis[0] && $('img', vis[0]);
      if (!lead || (lead.complete && lead.naturalWidth > 0)) { filterGallery(colour); return; }
      var done = false;
      var go = function () { if (done || turn !== galleryTurn) return; done = true; filterGallery(colour); };
      if (typeof lead.decode === 'function') lead.decode().then(go, go);
      else lead.addEventListener('load', go, { once: true });
      setTimeout(go, 350);
    }
    function buildAngles(vis) {
      if (!angles) return;
      angles.innerHTML = '';
      if (vis.length < 2) return;
      vis.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dw-pdp__angle'; b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.textContent = s.dataset.angle || ('Photo ' + (i + 1));
        b.addEventListener('click', function () {
          if (gallery) gallery.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
        });
        angles.appendChild(b);
      });
    }
    if (gallery && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || e.intersectionRatio < .6) return;
          var vis = visibleSlides(); var i = vis.indexOf(e.target);
          if (i < 0 || !angles) return;
          $$('.dw-pdp__angle', angles).forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        });
      }, { root: gallery, threshold: [.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    /* zoom */
    var dialog = $('[data-dw-dialog]', root);
    var dialogImg = $('[data-dw-dialog-img]', root);
    $$('[data-dw-zoom]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!dialog || !dialogImg || typeof dialog.showModal !== 'function') { window.open(b.dataset.full, '_blank'); return; }
        dialogImg.src = b.dataset.full;
        dialogImg.alt = ($('img', b) || {}).alt || '';
        dialog.showModal();
      });
    });
    if (dialog) {
      var closeBtn = $('[data-dw-dialog-close]', dialog);
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
    /* sleeve marks: open the matching sleeve photo (current colour first) */
    $$('[data-dw-mark]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var want = b.getAttribute('data-dw-mark');
        var hit = visibleSlides().filter(function (s) { return s.dataset.angle === want; })[0] ||
                  slides.filter(function (s) { return s.dataset.angle === want; })[0];
        var z = hit ? $('[data-dw-zoom]', hit) : null;
        if (z) z.click();
      });
    });
    filterGallery(ci >= 0 ? picks[ci] : '');
    /* once the page is idle, fetch each other colour's first photo so a tap swaps at once */
    if (ci >= 0 && !frugal) {
      var colourGroup = groups.filter(function (g) { return Number(g.dataset.dwOpt) === ci; })[0];
      var others = colourGroup ? $$('[data-dw-val]', colourGroup).map(function (b) { return b.dataset.dwVal; }) : [];
      var warmStart = function () { idle(function () { others.forEach(function (c) { if (c !== picks[ci]) warmColour(c, 1); }); }); };
      if (document.readyState === 'complete') warmStart();
      else window.addEventListener('load', warmStart, { once: true });
    }

    /* ---------- add to bag ---------- */
    var busy = false;
    function nudge() {
      var i = picks.indexOf('');
      var g = groups.filter(function (x) { return Number(x.dataset.dwOpt) === i; })[0];
      if (!g) return;
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      g.classList.remove('is-nudge'); void g.offsetWidth; g.classList.add('is-nudge');
      var first = $('[data-dw-val]:not(.is-off)', g);
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
    }
    function fail(msg) {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      var d = DW(); if (d) d.toast(msg);
    }
    function add() {
      if (busy) return;
      if (!complete()) { nudge(); return; }
      var v = current();
      if (!v || !v.a) { fail('That combination is not available right now.'); return; }
      var d = DW();
      if (!d || !d.addVariant) { if (form) form.submit(); return; }
      busy = true;
      [cta, dockCta].forEach(function (b) { if (b) { b.classList.add('is-busy'); b.disabled = true; } });
      d.addVariant(v.id).then(function (json) {
        var drawer = $('cart-drawer');
        if (afterAdd === 'drawer' && drawer && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents(json); } catch (e) { d.syncTheme(json); d.toast('Added to your bag', 'View bag', d.cartUrl); }
        } else {
          d.syncTheme(json);
          d.toast('Added ' + [data.title].concat(picks.filter(Boolean)).join(', '), 'View bag', d.cartUrl);
        }
        document.dispatchEvent(new CustomEvent('smt:cart:updated', { detail: { source: 'dw-pdp', variantId: v.id } }));
      }).catch(function (err) {
        fail(err && err.message ? err.message : 'Could not add to bag. Try again.');
      }).then(function () {
        busy = false;
        [cta, dockCta].forEach(function (b) { if (b) { b.classList.remove('is-busy'); b.disabled = false; } });
        paint();
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    if (dockCta) dockCta.addEventListener('click', add);

    /* ---------- dock ---------- */
    /* floating app buttons (chat, rewards, review badges) live in the bottom corners, where the
       dock sits: while the dock is up they move up by its height, then go back. Only small fixed
       boxes that touch the dock move; bars, drawers and dialogs are left alone. */
    var lifted = [], liftTimer = null;
    function lift(on) {
      var h = on && dock ? Math.ceil(dock.getBoundingClientRect().height) : 0;
      var html = document.documentElement;
      html.style.setProperty('--dw-dock-h', h + 'px');
      html.classList.toggle('dw-dock-on', !!on);
      lifted.forEach(function (x) { x.style.translate = x.dataset.dwTranslate || ''; delete x.dataset.dwLifted; delete x.dataset.dwTranslate; });
      lifted = [];
      if (!on) return;
      var vh = window.innerHeight, vw = window.innerWidth;
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (/^(SCRIPT|STYLE|LINK|NOSCRIPT|TEMPLATE|MAIN|HEADER|FOOTER)$/.test(el.tagName)) return;
        [el, el.firstElementChild].forEach(function (x) {
          if (!x || x.dataset.dwLifted || x.closest('.dw')) return;
          var cs = window.getComputedStyle(x);
          if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
          var r = x.getBoundingClientRect();
          if (!r.width || !r.height || r.height > 160 || r.width > vw * 0.6) return;
          if (r.bottom < vh - h - 4) return;
          x.dataset.dwLifted = '1';
          x.dataset.dwTranslate = x.style.translate || '';
          x.style.translate = '0 -' + h + 'px';
          lifted.push(x);
        });
      });
    }
    if (dock && cta && 'IntersectionObserver' in window) {
      var below = false;
      var show = function () {
        var on = below && !desktop.matches;
        dock.classList.toggle('is-visible', on);
        dock.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (dockCta) dockCta.tabIndex = on ? 0 : -1;
        lift(on);
        /* chat and rewards buttons often load a few seconds late: look again once */
        clearTimeout(liftTimer);
        if (on) liftTimer = setTimeout(function () { if (dock.classList.contains('is-visible')) lift(true); }, 2500);
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { below = !e.isIntersecting && e.boundingClientRect.top < 0; });
        show();
      }, { threshold: 0 }).observe(cta);
      /* a fast fling or a jump link can carry the button from below the screen to above it
         without the observer ever seeing it cross, so scrolling checks too (once a frame) */
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var past = cta.getBoundingClientRect().bottom < 0;
          if (past !== below) { below = past; show(); }
        });
      }, { passive: true });
      desktop.addEventListener && desktop.addEventListener('change', show);
    }

    /* ---------- size finder ---------- */
    var finder = $('[data-dw-finder]', root);
    var fitPanel = $('[data-dw-fit-panel]', root);
    var openFit = $('[data-dw-open-fit]', root);
    if (openFit && fitPanel) openFit.addEventListener('click', function () {
      fitPanel.open = true;
      fitPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var sel = $('[data-dw-finder-chest]', fitPanel); if (sel) setTimeout(function () { sel.focus({ preventScroll: true }); }, 400);
    });
    if (finder && (data.sizeTable || []).length) {
      var chest = $('[data-dw-finder-chest]', finder);
      var out = $('[data-dw-finder-out]', finder);
      var prefs = $$('[data-dw-prefer]', finder);
      var prefer = 'regular';
      var minEase = { fitted: 1, regular: 3, relaxed: 6 };
      function recommend() {
        var body = Number(chest && chest.value);
        $$('tr[data-dw-row]', root).forEach(function (r) { r.classList.remove('is-pick'); });
        if (!body || !out) { if (out) out.textContent = ''; return; }
        var pick = null;
        for (var i = 0; i < data.sizeTable.length; i++) {
          var row = data.sizeTable[i]; var circ = row.chest * 2;
          if (circ - body >= minEase[prefer]) { pick = row; break; }
        }
        if (!pick) pick = data.sizeTable[data.sizeTable.length - 1];
        var room = pick.chest * 2 - body;
        var d = DW();
        var esc = d ? d.esc : function (s) { return String(s); };
        out.innerHTML = 'We would pick <b>' + esc(pick.size) + '</b>: garment chest ' + (pick.chest * 2) + '", about ' + Math.max(0, Math.round(room)) + '" of room.';
        if (si >= 0 && sizeAvailable(pick.size)) {
          var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Select ' + pick.size;
          b.addEventListener('click', function () { picks[si] = pick.size; paint(); cta && cta.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
          out.appendChild(b);
        }
        var tr = $('tr[data-dw-row="' + String(pick.size).replace(/"/g, '\\"') + '"]', root);
        if (tr) tr.classList.add('is-pick');
      }
      if (chest) chest.addEventListener('change', recommend);
      prefs.forEach(function (b) {
        b.addEventListener('click', function () {
          prefer = b.dataset.dwPrefer;
          prefs.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          recommend();
        });
      });
    }

    paint();
  }

  function boot(root) { $$('[data-dw-pdp]', root).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  PDP.boot = boot;
})();
